
import { defineComponent } from 'vue';
import {
  ActivityIndicator,
  AjaxHelper,
  Matomo,
  SiteSelector,
  translate,
} from 'CoreHome';

export default defineComponent({
  components: {
    ActivityIndicator,
    SiteSelector,
  },
  data() {
    return {
      site: {
        id: Matomo.idSite,
        name: Matomo.currentSiteName,
      },
      groupAccess: new Map<string, string>(),
      isLoading: false,
      confirmUpdateAccessToAllSitesText: '',
    };
  },
  methods: {
    onSetAccessClicked(event: MouseEvent, groupName: string, access: string) {
      const idSite = this.site.id;

      if (idSite === 'all') {
        this.confirmUpdateAccessToAllSitesText = translate('GroupPermissions_ChangeAccessToAllSitesConfirm', access, groupName);
        Matomo.helper.modalConfirm('#confirmUpdateAccessToAllSites', {
          yes: () => this.updateGroupAccess(idSite, groupName, access),
        });
      } else {
        this.updateGroupAccess(idSite, groupName, access);
      }
    },
    updateGroupAccess(idSite: number|string, groupName: string, access: string) {
      this.isLoading = true;

      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.setGroupAccess',
      }, {
        idSites: idSite,
        name: groupName,
        access,
      },
      {
        errorElement: '#ajaxErrorAccessGroupMember',
      }).then(() => {
        this.groupAccess.set(groupName, access);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    updateGroupAccessList() {
      this.isLoading = true;

      const idSite = this.site.id;

      if (idSite === 'all') {
        AjaxHelper.post({
          module: 'API',
          format: 'json',
          method: 'GroupPermissions.getAllGroups',
        }, {
        },
        {
          errorElement: '#ajaxErrorAccessGroupMember',
        }).then((response) => {
          this.groupAccess.clear();

          const groupAccessTmp: string[] = [];

          response.forEach((group: { name: string }) => {
            groupAccessTmp.push(group.name);
          });

          groupAccessTmp.sort().forEach((group) => {
            this.groupAccess.set(group, 'noaccess');
          });
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        AjaxHelper.post({
          module: 'API',
          format: 'json',
          method: 'GroupPermissions.getGroupAccessFromSite',
        }, {
          idSite: this.site.id,
        },
        {
          errorElement: '#ajaxErrorAccessGroupMember',
        }).then((response) => {
          this.groupAccess.clear();

          Object.keys(response).sort().forEach((group) => {
            this.groupAccess.set(group, response[group]);
          });
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
  },
  computed: {
    hasSuperUserAccess() {
      return !!Matomo.hasSuperUserAccess;
    },
  },
});
